<template>
    <div class="top_rated container py-5">
        <div class="row bg-grey rounded-3">
            <div
                class="col-12 col-md-5 d-flex flex-column justify-content-center px-5 py-5 text-center text-md-start animate-fade-in">
                <h3 class="font-gothic-cond fw-bold mb-3">Tailored solutions for our partners, big and small</h3>
                <p class="font-gothic-cond fw-bolder ft-16 mb-4">
                    Whether you are a property owner, short-let manager, or a broker, our tailored solutions connect you
                    with millions of verified renters with assured rental income.
                </p>
                <router-link to="/signup/subscriber"
                    class="btn btn-cta btn-cta--small fs-16 w-100 w-md-50 py-3 px-3">List your property</router-link>
            </div>

            <div class="col-12 col-md-7 mt-4 mt-md-0">
                <div class="bg-white pad2 rounded-3 p-4 text-center animate-slide-up">
                    <img src="@/assets/images/logo_black.png" class="mb-3 img-fluid w-25" />
                    <hr class="hr w-100" />
                    <p class="ft-10 text-success mt-4 mb-2">Earn more money on your available rooms</p>
                    <h3 class="text-black ft-16 fw-bold pb-3  mx-auto">Millions of vetted renters, a modern marketplace.
                    </h3>

                    <div class="d-flex flex-column flex-md-row gap-3 pb-4 justify-content-center">
                        <img src="@/assets/images/tailored-house1.svg" class="img-fluid house-img "
                            alt="House illustration" />
                        <img src="@/assets/images/tailored-house2.svg" class="img-fluid house-img "
                            alt="House illustration" />
                        <img src="@/assets/images/tailored-house3.svg" class="img-fluid house-img "
                            alt="House illustration" />
                    </div>
                    <p class="fs-14 text-body mb-2">Have concerns and want to speak with our property teams?</p>
                    <button type="button" class="btn btn-cta fs-16 w-75 w-md-25">Schedule a call</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.pad1 {
    padding: 85px 65px;
}

.pad2 {
    margin: 30px;
    border-radius: 10px;
}

.bg-grey {
    background-color: #F0EEE6;
    border-radius: 10px;
}

.mp-width {
    width: 280px;
}

.house-img {
    transition: transform 0.3s ease;
}

.house-img:hover {
    transform: scale(1.05);
}

@media (max-width: 767.98px) {
    .house-img {
        max-width: 100%;
        margin-bottom: 1rem;
    }

    .d-flex.flex-column.flex-md-row.gap-3 {
        gap: 1rem !important;
    }
}
</style>
